
































































































































































import Vue from 'vue'
import { debounce } from 'lodash'
import PictureMaskLine from './PictureMaskLine.vue'
import PictureUtil from '../../utils/take_picture/picture_util'

export type DataType = {
  played: boolean
  stream: MediaStream | null
  taken: boolean
  video_size: { w: number; h: number }
  video_tag_size: { w: number; h: number }
  isVertical: boolean
}

interface Point {
  x: number
  y: number
}

interface VideoConstraints {
  width: number
  height: number
}

export default Vue.extend({
  components: {
    PictureMaskLine
  },

  props: {
    correctSize: {
      type: Object,
      required: true
    },
    isBack: {
      type: Boolean,
      default: false
    },
    isPaperHorizontal: {
      type: Boolean,
      default: false
    },
    uploading: {
      type: Boolean,
      default: false
    },
    clipScale: {
      type: Number,
      default: 0.8
    }
  },

  data(): DataType {
    return {
      /**
       * 映像が再生されたか
       */
      played: false,
      /**
       * メディアコンテンツのストリーム
       */
      stream: null,
      /**
       * 撮影ボタンが押されたか
       */
      taken: false,
      /**
       * ビデオのサイズ
       */
      video_size: { w: 0, h: 0 },
      /**
       * ビデオ要素のサイズ
       */
      video_tag_size: { w: 0, h: 0 },
      /**
       * 端末が縦向きかどうか
       */
      isVertical: true,
    }
  },

  computed: {
    /**
     * ビデオストリームの制約
     */
    constraints(): VideoConstraints {
      return { width: this.correctSize.h, height: this.correctSize.w }
    },

    /**
     * 枠線表示の基準点
     */
    guide(): { p0: Point; p1: Point; p2: Point; p3: Point } {
      if (this.video_tag_size) {
        return this.makeGuide(this.video_tag_size)
      } else {
        return {
          p0: { x: 0, y: 0 },
          p1: { x: 0, y: 0 },
          p2: { x: 0, y: 0 },
          p3: { x: 0, y: 0 }
        }
      }
    },

    /**
     * 線の色
     */
    lineColor(): string {
      return '#DA2C38'
    },

    orientationChangeEventFunc() {
      return () => {
        // setTimeoutで画面の回転が完了した後に行う
        setTimeout(async () => {
          this.stream = await this.getMedia(this.constraints)
          this.refresh()
        }, 500)
      }
    },

    resizeEventFunc() {
      return debounce(async () => {
        this.refresh()
      }, 1000)
    },

    /**
     * ビデオ要素
     */
    video(): HTMLVideoElement {
      return this.$refs.my_video as HTMLVideoElement
    },

    /**
     * ビデオコンテナ要素
     */
    videoContainer(): HTMLElement {
      return this.$refs['video_container'] as HTMLElement
    },

    /**
     * 撮影ボタン要素
     */
    takeButtonEl(): HTMLButtonElement {
      return this.$refs['take_button'] as HTMLButtonElement
    },

    /**
     *
     */
    videoGuide(): { p0: Point; p1: Point; p2: Point; p3: Point } {
      return this.makeGuide(this.video_size)
    }
  },

  async mounted() {
    this.stream = await this.getMedia(this.constraints)
    window.addEventListener('resize', this.resizeEventFunc)
    window.addEventListener(
      'orientationchange',
      this.orientationChangeEventFunc
    )
  },

  beforeDestroy() {
    this.stream = null
    window.removeEventListener('resize', this.resizeEventFunc)
    window.removeEventListener(
      'orientationchange',
      this.orientationChangeEventFunc
    )
    this.played = false

    if (this.video) {
      const srcObject = this.video.srcObject as MediaStream
      if (srcObject) {
        srcObject.getVideoTracks().forEach((track: any) => {
          track.stop()
          srcObject.removeTrack(track)
        })
      }
      this.video.pause()
      this.video.removeAttribute('src')
      this.video.removeAttribute('srcObject')
      this.video.load()
    }
  },

  methods: {
    /**
     * ビデオ再生開始時の処理です
     */
    begin_played() {
      this.played = true
      this.refresh()
    },

    /**
     * メディアストリームを取得します
     */
    async getMedia({
      width,
      height
    }: VideoConstraints): Promise<MediaStream | null> {
      let stream: MediaStream | null = null
      try {
        if (this.isPaperHorizontal) {
          const constraints = {
            audio: false,
            video: {
              facingMode: 'environment',
              height: { ideal: width },
              aspectRatio: this.isPaperHorizontal ? height / width : width / height
            }
          }
          return await navigator.mediaDevices.getUserMedia(constraints)
        } else {
          const constraints = {
            audio: false,
            video: {
              facingMode: 'environment',
              width: { ideal: width },
              aspectRatio: this.isPaperHorizontal ? height / width : width / height
            }
          }
          return await navigator.mediaDevices.getUserMedia(constraints)
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },

    /**
     * 枠線表示の基準点を作成します
     */
    makeGuide(size: {
      w: number
      h: number
    }): { p0: Point; p1: Point; p2: Point; p3: Point } {
      const c_size = { w: this.correctSize.w, h: this.correctSize.h }
      const v_size = { w: size.w, h: size.h }
      let h = 0
      let w = 0
      if (c_size.w / c_size.h < v_size.w / v_size.h) {
        h = v_size.h * this.clipScale
        w = (h / c_size.h) * c_size.w
      } else {
        w = v_size.w * this.clipScale
        h = (w / c_size.w) * c_size.h
      }
      const t = (v_size.h - h) / 2
      const l = (v_size.w - w) / 2
      const m = 0
      // const m = w * 0.05;  //台形度合い
      // 左上＝＞右上＝＞右下＝＞左下
      return {
        p0: { x: l + m, y: t },
        p1: { x: l + w - m, y: t },
        p2: { x: l + w, y: t + h },
        p3: { x: l, y: t + h }
      }
    },

    /**
     * 画面更新します
     */
    refresh(): void {
      this.isVertical = window.outerWidth < window.outerHeight
      this.refreshVideoSize()
      this.refreshButtonPosition()
    },

    /**
     * ビデオサイズを更新します
     */
    refreshVideoSize(): void {
      this.video_size = { w: this.video.videoWidth, h: this.video.videoHeight }

      this.videoContainer.setAttribute(
        'style',
        `transform: translateX(${
          -this.video.clientWidth / 2 + document.documentElement.clientWidth / 2
        }px)`
      )

      if (this.isVertical) {
        this.video.removeAttribute('style')
      } else {
        this.video.setAttribute('style', 'height: 100%')
      }

      this.video_tag_size = {
        w: this.video.clientWidth,
        h: this.video.clientHeight
      }

      window.scrollTo(0, 1)
    },

    /**
     * ボタンの位置を更新します
     */
    refreshButtonPosition(): void {
      if (this.isVertical) {
        this.takeButtonEl.setAttribute('style', 'bottom:1rem;left:0;right:0;')
      } else {
        this.takeButtonEl.setAttribute('style', 'bottom:0;right:1rem;top:0;')
      }
    },

    /**
     * 写真を撮影します
     */
    take() {
      // if (this.taken) {
      //   return
      // }

      this.taken = true

      // キャンバス要素を作成
      let canvas: HTMLCanvasElement | null = document.createElement('canvas')
      canvas.width = this.video_size.w
      canvas.height = this.video_size.h
      // console.debug(`width=${canvas.width}, height=${canvas.height}`)

      // キャンバス要素に映像を描き込む
      const ctx = canvas.getContext('2d')!
      ctx.drawImage(this.video, 0, 0, canvas.width, canvas.height)

      // 赤枠に対するオフセット値を算出する
      // 赤枠よりやや拡張してクリップするようにするため
      const offset_x = this.video_size.w * 0.05
      const offset_y = this.video_size.h * 0.05
      // console.debug(`offset_x=${offset_x}, offset_y=${offset_y}`)

      // クリップする時の上端、左端、幅、高さを取得する
      const l = this.videoGuide.p0.x - offset_x
      const t = this.videoGuide.p0.y - offset_y
      const w = this.videoGuide.p2.x - this.videoGuide.p0.x + offset_x * 2
      const h = this.videoGuide.p2.y - this.videoGuide.p0.y + offset_y * 2
      // console.debug(`l=${l}, t=${t}, w=${w}, h=${h}`)

      this.$emit('taken', { canvas, l, t, w, h })

      PictureUtil.disposeCanvas(canvas)
      canvas = null
    }
  }
})
